import { useCallback, useState } from "react";

import { PaymentsWalletsService } from "../services/paymentsWallets.service";

export interface UseWalletArrangementResult {
  isSavingOrder: boolean;
  isDeleting: boolean;
  /** Saves the order of the organization's wallets, first to last. Throws so the caller can show why. */
  saveOrder: (walletIds: string[]) => Promise<void>;
  /**
   * Deletes a wallet that was never used. Throws on failure — a 409 `wallet_in_use` carries the reason in its
   * message, which the caller shows as is.
   */
  deleteWallet: (walletId: string) => Promise<void>;
}

/** How an organization arranges its wallets on the home: their order, and removing one it never used. */
export const useWalletArrangement = (): UseWalletArrangementResult => {
  const [isSavingOrder, setIsSavingOrder] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const saveOrder = useCallback(async (walletIds: string[]) => {
    setIsSavingOrder(true);
    try {
      await PaymentsWalletsService.reorder(walletIds);
    } finally {
      setIsSavingOrder(false);
    }
  }, []);

  const deleteWallet = useCallback(async (walletId: string) => {
    setIsDeleting(true);
    try {
      await PaymentsWalletsService.remove(walletId);
    } finally {
      setIsDeleting(false);
    }
  }, []);

  return { isSavingOrder, isDeleting, saveOrder, deleteWallet };
};
